webpackJsonp([115898287384546],{

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _APIDetailsSectionModule = __webpack_require__(649);
	
	var _APIDetailsSectionModule2 = _interopRequireDefault(_APIDetailsSectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _imgLaptopZoneAndWeight = __webpack_require__(49);
	
	var _imgLaptopZoneAndWeight2 = _interopRequireDefault(_imgLaptopZoneAndWeight);
	
	var _imgLaptopZoneAndWeight2x = __webpack_require__(50);
	
	var _imgLaptopZoneAndWeight2x2 = _interopRequireDefault(_imgLaptopZoneAndWeight2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _Animations.ScrollOverPack,
	        { className: 'src-components----APIDetailsSection-module---api-details-section---2-bDl' },
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: 'container', component: _reactstrap.Container }, _Animations.FadeUp),
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----APIDetailsSection-module---text-container---2aai-' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Get deeper insights'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Deliver better experiences.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'src-components----APIDetailsSection-module---message---17-I0' },
	                    'Have you ever wondered how delivery speed affects customer retention? Or wanted to calculate your fully-loaded unit costs? Joining accurate, shipment-level data with what\u2019s already in your database can lead you to powerful insights with actionable outcomes.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: 'splash-image-container',
	                className: 'src-components----APIDetailsSection-module---splash-image-container---378mC'
	            }, _Animations.FadeRight),
	            _react2.default.createElement(_RetinaImage2.default, { srcSet: [_imgLaptopZoneAndWeight2.default, _imgLaptopZoneAndWeight2x2.default],
	                className: 'src-components----APIDetailsSection-module---splash-image---2eLjJ' })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"api-details-section":"src-components----APIDetailsSection-module---api-details-section---2-bDl","text-container":"src-components----APIDetailsSection-module---text-container---2aai-","message":"src-components----APIDetailsSection-module---message---17-I0","splash-image-container":"src-components----APIDetailsSection-module---splash-image-container---378mC","splash-image":"src-components----APIDetailsSection-module---splash-image---2eLjJ"};

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-coding.d3b1e7d6.jpg";

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-coding@2x.340fc1ed.jpg";

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-coding@3x.207c4343.jpg";

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dashboardModule = __webpack_require__(55);
	
	var _dashboardModule2 = _interopRequireDefault(_dashboardModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _APIDetailsSection = __webpack_require__(359);
	
	var _APIDetailsSection2 = _interopRequireDefault(_APIDetailsSection);
	
	var _FeaturesLinksSection = __webpack_require__(51);
	
	var _FeaturesLinksSection2 = _interopRequireDefault(_FeaturesLinksSection);
	
	var _TestimonialsSection = __webpack_require__(91);
	
	var _TestimonialsSection2 = _interopRequireDefault(_TestimonialsSection);
	
	var _UptimeSplash = __webpack_require__(92);
	
	var _UptimeSplash2 = _interopRequireDefault(_UptimeSplash);
	
	var _imgCoding = __webpack_require__(782);
	
	var _imgCoding2 = _interopRequireDefault(_imgCoding);
	
	var _imgCoding2x = __webpack_require__(783);
	
	var _imgCoding2x2 = _interopRequireDefault(_imgCoding2x);
	
	var _imgCoding3x = __webpack_require__(784);
	
	var _imgCoding3x2 = _interopRequireDefault(_imgCoding3x);
	
	var _iconApi = __webpack_require__(223);
	
	var _iconApi2 = _interopRequireDefault(_iconApi);
	
	var _iconApi2x = __webpack_require__(224);
	
	var _iconApi2x2 = _interopRequireDefault(_iconApi2x);
	
	var _iconApi3x = __webpack_require__(225);
	
	var _iconApi3x2 = _interopRequireDefault(_iconApi3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-pages-features----dashboard-module---hero---RX6K-' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages-features----dashboard-module---text-container---3CHyn' },
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_iconApi2.default, _iconApi2x2.default, _iconApi3x2.default] }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 mt-2' },
	                    'API'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Unleash your data.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-pages-features----dashboard-module---message---TYnoZ' },
	                    'Gain even more insight. Use the API to pull Galleon\'s clean, normalized shipping data into your own data warehouse for advanced analysis.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-pages-features----dashboard-module---button---3mu4_', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-pages-features----dashboard-module---splash-image-container---1iBIF' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgCoding2.default, _imgCoding2x2.default, _imgCoding3x2.default],
	                className: 'src-pages-features----dashboard-module---splash-image---1LZSu'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(Hero, null),
	        _react2.default.createElement(_APIDetailsSection2.default, null),
	        _react2.default.createElement(_TestimonialsSection2.default, null),
	        _react2.default.createElement(_UptimeSplash2.default, null),
	        _react2.default.createElement(_FeaturesLinksSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-api-js-2038491c5c485e081901.js